import classNames from 'classnames'
import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import cl from '../../../classnames.scss'
import s from './description.scss'
import {DescriptionProps} from './index'

export const Description = ({description, descriptionVisible, isSideBySideHeaderLayout}: DescriptionProps) => {
  return descriptionVisible ? (
    <div className={s.descriptionSpacing}>
      <p
        className={classNames(s.eventDescription, cl.evDescriptionFont, cl.evDescriptionColor, {
          [s.sideBySide]: isSideBySideHeaderLayout,
        })}
        data-hook={DH.headerEventDescription}
      >
        {description}
      </p>
    </div>
  ) : null
}
